var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('section',{staticClass:"w-full flex justify-center"},[_c('h3',{staticClass:"text-center text-white animated flash infinite my-6"},[_vm._v("LOADING")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }